import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M849 685q-2-14-14-32.5t-19-9.5q4 10-1 14.5t-12 2.5-8.5-9.5T802 633q-25-25-68-67l-43-44q-3 1-14.5 12.5T661 549q-3 2-5.5-.5T660 534l4-7-403-402-110 110 22 48 11-8 18 37 11-10 18 39 9-9 19 38 9-10 18 37 10-11 17 39 11-12 18 40 9-10 19 39 11-11 17 39 11-12 17 40 10-11 18 38 9-9 19 38 10-10 18 37 9-10 19 39 9-9 19 37 10-11 19 38 9-9 20 39 10-11 17 40 59-60 2 3q4 3 9 5t13 2 13-2.5 5-4.5-3-4.5-4-5.5q-1-5 2.5-14t11-11.5 19 3.5 14 21-5 25.5T734 782l-19 20-8 9q-9 7-12 11-5 7-5 14 0 17 19.5 29.5T753 875q1-2 0-9-2-17 2-28l1-1q7-17 14-28 12-19 34-42 5-6 15-16 17-18 23-28 9-17 7-38zm-127-37q-8 0-13-5t-5-13.5 5-13.5 13.5-5 14 5 5.5 13q0 19-20 19z" })
});
export default SvgCrp;
